import React from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import { StepWrapper } from '../StepWrapper';
import { UserSetup } from '@/pages/UserSetup';
import { useOnboarding } from '@/contexts/OnboardingContext';

interface StepUserAccessProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  /** Navigate to the Resources page — provided by OnboardingWizard */
  onNavigateToResources: () => void;
}

export function StepUserAccess({ onNext, onBack, onSkip, onNavigateToResources }: StepUserAccessProps) {
  const { pauseForBulk } = useOnboarding();

  const handleAssignBulk = () => {
    // Pause (not dismiss) so the wizard reopens when the admin returns
    pauseForBulk();
    onNavigateToResources();
  };

  return (
    <StepWrapper
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
      nudgeMessage="Assign roles and company access to your Evo users. You can also allocate users in bulk from the Resources screen."
      extraActions={
        <Button
          variant="outline"
          size="sm"
          className="gap-2 text-muted-foreground"
          onClick={handleAssignBulk}
        >
          <ExternalLink className="h-3.5 w-3.5" />
          Assign in Bulk via Resources →
        </Button>
      }
    >
      {/*
        UserSetup uses `h-full overflow-y-auto` at its root, so we give it a
        min-height so it doesn't collapse when the parent has no fixed height.
      */}
      <div className="min-h-[600px] overflow-hidden">
        <UserSetup />
      </div>
    </StepWrapper>
  );
}
